// @ts-nocheck
import { all, call, put, takeLatest } from "redux-saga/effects";

import { Axios } from "../../api/axios";
import { getSimplifiedError } from "../../utils/error";
import {
  ONBOARDING_DETAILS_SAVE_REQUEST,
  ONBOARDING_DETAILS_SAVE_SUCCESS,
  ONBOARDING_DETAILS_SAVE_ERROR,
} from "../reducers/OnboardingReducer";
import { toast } from "react-toastify";

async function onboardingAPI(payload) {
  return await Axios.post("/user/onboarding_done/", payload);
}
function* handleOnboardingAPI({ payload }) {
  try {
    const response = yield call(onboardingAPI, payload);
    if (response) {
      yield put({
        type: ONBOARDING_DETAILS_SAVE_SUCCESS,
      });
    }
  } catch (error) {
    toast(getSimplifiedError(error), {
      type: "error",
      position: "bottom-left",
      toastId: "details-save",
    });
    yield put({
      type: ONBOARDING_DETAILS_SAVE_ERROR,
      error: getSimplifiedError(error),
    });
  }
}

export default all([
  takeLatest(ONBOARDING_DETAILS_SAVE_REQUEST, handleOnboardingAPI),
]);
